import { useEffect } from "react";
import { Show } from "react-admin";
import { useParams } from "react-router-dom";

import mixpanel from "mixpanel-browser";

import PatientHeader from "./PatientHeader";
import PatientTabs from "./PatientTabs";
import {
  getPatientProjectContext,
  onPatientShowMount,
  onPatientShowUnmount
} from "../../project/ProjectShow/ProjectNavigationContext";

const PatientShow = () => {
  mixpanel.track("PatientShow");

  const { id: patientId } = useParams();
  const projectContext = patientId ? getPatientProjectContext(patientId) : null;

  useEffect(() => {
    onPatientShowMount();
    return onPatientShowUnmount;
  }, []);

  return (
    <Show
      title="Patient Details"
      emptyWhileLoading
      actions={false}
      component="div"
    >
      <PatientHeader projectContext={projectContext} />
      <PatientTabs projectContext={projectContext} />
    </Show>
  );
};

export default PatientShow;
